/**
 * Delega - SPECIFICHE 2.4
 *
 * Deleghe sindacali, collegate al lavoratore.
 *
 * Stati (SPECIFICHE 4.1 - campo esplicito `stato`):
 * - BOZZA: appena creata, modificabile
 * - DA_PRESENTARE: pronta per la presentazione alla cassa
 * - PRESENTATA: inviata alla cassa, in attesa di riscontro
 * - CONFERMATA: riscontro positivo dalla cassa
 * - ARCHIVIATA: non piu' attiva (con motivo)
 */
import { z } from 'zod';
import { CassaCodeSchema, str, dateStr } from './common.ts';

// Stati delega
export const STATI_DELEGA = ['BOZZA', 'DA_PRESENTARE', 'PRESENTATA', 'CONFERMATA', 'ARCHIVIATA'] as const;
export const StatoDelegaSchema = z.enum(STATI_DELEGA);
export type StatoDelega = z.infer<typeof StatoDelegaSchema>;

// Motivi archiviazione
export const MOTIVI_ARCHIVIAZIONE = ['RIFIUTATA', 'CESSATO', 'DIMESSO', 'ALTRO'] as const;
export const MotivoArchiviazioneSchema = z.enum(MOTIVI_ARCHIVIAZIONE);
export type MotivoArchiviazione = z.infer<typeof MotivoArchiviazioneSchema>;

export const DelegaSchema = z.object({
  id: z.number(),
  lavoratoreId: z.number(),
  cassa: CassaCodeSchema,
  stato: StatoDelegaSchema.default('DA_PRESENTARE'),
  dataPresentazione: dateStr,
  dataDecorrenza: dateStr,
  dataCessazione: dateStr,
  dataConferma: dateStr,
  dataArchiviazione: dateStr,
  motivoArchiviazione: MotivoArchiviazioneSchema.nullable().default(null),
  operatore: str,
  note: str,
  daArchivio: z.number().default(0),
  createdAt: str,
  updatedAt: str,
});

export type Delega = z.infer<typeof DelegaSchema>;

// Per INSERT (senza id e timestamp)
export const DelegaInsertSchema = DelegaSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
}).extend({
  stato: StatoDelegaSchema.default('DA_PRESENTARE'),
});

export type DelegaInsert = z.infer<typeof DelegaInsertSchema>;
